import { Box, Button, Flex, IconButton, Text, Tooltip } from '@chakra-ui/react';
import { mdiAccountRemoveOutline, mdiClose } from '@mdi/js';
import React from 'react';
import { PortalIcon } from '../PortalIcon';

export interface SelectBarProps {
  selectedCount: number;
  onDeselectAll: () => void;
  onDelete: () => void;
  isRemoveDisabled?: boolean;
}

export const SelectBar: React.FC<SelectBarProps> = ({
  selectedCount,
  onDeselectAll,
  onDelete,
  isRemoveDisabled = false,
}) => {
  return (
    <Box
      bg='primary'
      display='flex'
      gap={10}
      alignItems='center'
      px={6}
      py={4}
      borderRadius='lg'
      boxShadow='lg'
      w='full'
    >
      <Flex gap={2} alignItems='center' flex='none'>
        <Tooltip
          label='Deselect all'
          placement='bottom'
          hasArrow
          bg='gray.700'
          color='white'
          fontSize='sm'
          px={2}
          py={0.5}
          borderRadius='sm'
        >
          <IconButton
            aria-label='Deselect all'
            icon={<PortalIcon path={mdiClose} />}
            size='sm'
            variant='ghost'
            colorScheme='whiteAlpha'
            color='white'
            borderRadius='full'
            onClick={onDeselectAll}
            _hover={{ bg: 'whiteAlpha.200' }}
          />
        </Tooltip>
        <Text fontSize='sm' fontWeight='normal' color='white'>
          {selectedCount} selected
        </Text>
      </Flex>

      <Flex gap={2} alignItems='center' justifyContent='flex-end' flex='none'>
        <Button
          leftIcon={<PortalIcon path={mdiAccountRemoveOutline} />}
          size='sm'
          variant='ghost'
          colorScheme='whiteAlpha'
          color='white'
          fontWeight='semibold'
          fontSize='sm'
          borderRadius='full'
          onClick={onDelete}
          isDisabled={isRemoveDisabled}
          _hover={{ bg: 'whiteAlpha.200' }}
          _disabled={{ opacity: 0.4, cursor: 'not-allowed' }}
        >
          Remove from group
        </Button>
      </Flex>
    </Box>
  );
};
